






import {Component, Vue} from 'vue-property-decorator';
import ContactMessage from '@/components/ContactMessage.vue';
import ImageLayout from '@/components/ImageLayout.vue';

@Component({
  components: {
    ContactMessage,
    ImageLayout,
  },
})
export default class Error extends Vue {
}
